import React, { useState }  from 'react'
import styled from 'styled-components'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'

import useDebouncedCallback from '~utilities/debounce'


import { useMutation } from '@apollo/client'
import { GEOCODE } from '../mutations/geocode'

const StyledField = styled.input`
  font-size: 14px !important;
  border: none !important;
  border-bottom: 1px solid #8a8a8a !important;
  box-shadow: none !important;
  padding: 0 !important;
`

const AddressGeocode = ({ onSelected, form, name, placeholder ,component, className, value }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [options, setOptions] = useState([])
  const [geocode, data] = useMutation(GEOCODE)

  const handleSearch = async query => {
    setIsLoading(true)
    let response
    if (query.length >= 3) {
      response = await geocode({ variables: { query } })
    }
    setOptions(response?.data?.geocode?.results || [])
    setIsLoading(false)
  }

  const debounceSearch = useDebouncedCallback(handleSearch)

  const onInputChange = value => {
    form.setFieldValue(name, value)
    debounceSearch(value)
  }

  const Field = component || StyledField
  return (
    <AsyncTypeahead
      filterBy={() => true} // Bypass client-side filtering by returning `true`
      id="address-geocode"
      isLoading={isLoading}
      labelKey="localPart"
      options={options}
      onSearch={debounceSearch}
      placeholder={placeholder}
      defaultInputValue={value}
      onChange={(p) => onSelected(p[0])}
      allowNew={true}
      newSelectionPrefix="My address isn't listed (specify custom address)."
      onInputChange={onInputChange}
      renderInput={({ inputRef, referenceElementRef, ...inputProps }) => (
        <Field {...inputProps} required className={className} ref={(input) => {
            // Be sure to correctly handle these refs. In many cases, both can simply receive
            // the underlying input node, but `referenceElementRef can receive a wrapper node if
            // your custom input is more complex (See TypeaheadInputMulti for an example).
            inputRef(input)
            referenceElementRef(input)
          }} />
      )}
      renderMenuItemChildren={(option, props) => (
        <div>
          <div>{option.localPart}, {option.city}, {option.stateCode} {option.postalCode}</div>
        </div>
      )}
    />
  )
}

export{ AddressGeocode }
